import dayjs from 'dayjs';

// --- Existing Formatters (Inhe rehne dein) ---
export const formatCurrency = (val) => {
  if (val === null || val === undefined) return '-';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
  }).format(val);
};

export const formatQty = (val, unit = '') => {
  if (val === null || val === undefined) return '-';
  const formattedVal = Number(val).toFixed(4);
  return unit ? `${formattedVal} ${unit}` : formattedVal;
};

export const formatDate = (val) => {
  if (!val) return '-';
  return dayjs(val).format('DD MMM YYYY');
};

export const formatDateTime = (val) => {
  if (!val) return '-';
  return dayjs(val).format('DD MMM YYYY hh:mm A');
};

// --- New Export Utility (Isko niche add kar dein) ---
export function exportToCSV(data, columns, filename) {
  // Sirf wahi columns ka data nikalna jo visible hain
  const headers = columns.filter(col => col.title && col.dataIndex).map(col => col.title).join(',');
  
  const rows = data.map(item => {
    return columns
      .filter(col => col.title && col.dataIndex)
      .map(col => {
        const val = item[col.dataIndex];
        // Agar value comma wali ho toh CSV break na ho isliye quotes use karte hain
        return `"${val !== undefined && val !== null ? val : ''}"`;
      }).join(',');
  });

  const csvContent = [headers, ...rows].join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  
  link.setAttribute("href", url);
  link.setAttribute("download", `${filename}_${dayjs().format('YYYYMMDD_HHmm')}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}